import React from 'react';
import data from '../../legal-content/faq.json';
import LegalDocument from '../../components/LegalDocument/LegalDocument';

const FaqPage = () => (
  <LegalDocument data={data} currentPage="FaqPage" showSidebar={false} />
);

export default FaqPage;
